export const MenuWfh = [
    {
      title: 'WORK FROM HOME JOBS IN BANGALORE',
      path: '/LOCATION',
      cName: 'dropdown-link'
    },
    {
      title: 'WORK FROM HOME JOBS IN MUMBAI',
      path: '/SKILLS',
      cName: 'dropdown-link'
    },
    {
      title: 'WORK FROM HOME JOBS IN DELHI',
      path: '/INDUSTRY',
      cName: 'dropdown-link'
    },
    {
      title: 'WORK FROM HOME JOBS IN HYDERABAD',
      path: '/COMPANY',
      cName: 'dropdown-link'
    }
  ];
  